import script from "./Page-Not-Found.vue?vue&type=script&setup=true&lang=js"
export * from "./Page-Not-Found.vue?vue&type=script&setup=true&lang=js"

import "./Page-Not-Found.vue?vue&type=style&index=0&id=524e07e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-524e07e9"]])

export default __exports__